module.exports = __webpack_public_path__ + "static/media/10.a2ad4ad7.jpg";